// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1CX0u","Success":"Button_Success__3bE5Q","Danger":"Button_Danger__2qIsR"};